import type { CsvHeaderAliases, CsvStatusAliases } from './dtos';

export const defaultCsvHeaderAliases: CsvHeaderAliases = {
  suite: ['suite', 'suite_name', 'suite_title'],
  test: ['test', 'test_name', 'case'],
  status: ['status', 'result', 'outcome'],
  duration: ['duration', 'duration_ms', 'elapsed'],
  timestamp: ['timestamp', 'started_at', 'finished_at'],
};

export const defaultCsvStatusAliases: CsvStatusAliases = {
  passed: ['pass', 'passed'],
  failed: ['fail', 'failed'],
  errored: ['error', 'errored', 'errored_out'],
  skipped: ['skip', 'skipped'],
  untested: ['untested', 'not_run', 'notrun', 'n/a', 'na', 'none', 'unknown'],
};
